'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _dismiss = require('../../dismiss');

var _dismiss2 = _interopRequireDefault(_dismiss);

require('../styles/Alert.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SHOW_ARIA_MESSAGE_TIMEOUT = 100;

function renderAriaMessage(content) {
  return _react2.default.createElement(
    'div',
    { role: 'alert', 'aria-live': 'polite', 'aria-atomic': 'true' },
    _react2.default.createElement(
      _baseScreenReaderMessage2.default,
      null,
      content
    )
  );
}

var Alert = function (_BcReactComponent) {
  _inherits(Alert, _BcReactComponent);

  function Alert(props) {
    _classCallCheck(this, Alert);

    var _this = _possibleConstructorReturn(this, (Alert.__proto__ || Object.getPrototypeOf(Alert)).call(this, props));

    _this.state = { showAriaMessage: false };
    return _this;
  }

  _createClass(Alert, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // NVDA only announces live regions which are added to the DOM directly.
      // For example, it does not work if a div _containing_ an aria-live region is added.
      // Adding the live region after a timeout ensures it's added separatly from the element that contains it.
      this._intervalId = setTimeout(function () {
        return _this2.setState({ showAriaMessage: true }, 0);
      }, SHOW_ARIA_MESSAGE_TIMEOUT);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this._intervalId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          renderIcon = _props.renderIcon,
          handleDismiss = _props.handleDismiss,
          children = _props.children;
      var showAriaMessage = this.state.showAriaMessage;

      var classNames = 'alert cp-alert ' + className;

      return _react2.default.createElement(
        'div',
        { className: classNames },
        renderIcon && _react2.default.createElement(
          'span',
          { className: 'alert-icon' },
          renderIcon()
        ),
        _react2.default.createElement(
          'div',
          { className: 'alert-content', 'aria-hidden': 'true' },
          children
        ),
        showAriaMessage && renderAriaMessage(children),
        handleDismiss && _react2.default.createElement(_dismiss2.default, { handleDismiss: handleDismiss })
      );
    }
  }]);

  return Alert;
}(_baseBcReactComponent2.default);

exports.default = Alert;


Alert.propTypes = {
  className: _react.PropTypes.string,
  renderIcon: _react.PropTypes.func,
  handleDismiss: _react.PropTypes.func,
  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node])
};

Alert.defaultProps = {
  className: ''
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-alerts/lib/components/alert/components/Alert.component.js
// module id = 871
// module chunks = 0 3